import { useEffect, useState } from "react";
import { Box, Spinner } from "@chakra-ui/react";

// Wait for the hero background image only — below-fold images are lazy loaded separately
const HERO_IMAGE = "homepage-hero-field.png";

export const PageLoadSpinner = (): JSX.Element | null => {
	const [loaded, setLoaded] = useState(false);

	useEffect(() => {
		const img = new window.Image();
		img.onload = () => setLoaded(true);
		img.onerror = () => setLoaded(true);
		img.src = HERO_IMAGE;
	}, []);

	if (loaded) return null;

	return (
		<Box
			position="fixed"
			inset={0}
			zIndex={9999}
			bg="white"
			display="flex"
			alignItems="center"
			justifyContent="center"
		>
			<Spinner size="xl" color="green.600" thickness="4px" speed="0.7s" />
		</Box>
	);
};
